module.exports = __webpack_public_path__ + "static/media/HTML.525f317f.svg";